var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"tab-list"},_vm._l((_vm.tabs),function(tab,idx){return _c('li',{key:idx,staticClass:"tab-list__item"},[_c('button',{staticClass:"tab-list__button",class:{ 'tab-list__button--active': _vm.activeTabIdx === idx },on:{"click":function($event){return _vm.handleTabClick(idx)}}},[_vm._v(" "+_vm._s(tab[_vm.tabKey])+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }